import React from "react";
import { Route, Routes } from "react-router-dom";
import { RequireAuth } from "../../Auth/require_auth";

// Import components
import ZwembadinspectiesDashboard from "./Dashboard/index";
import SwimmingPoolsPage from "./SwimmingPools/index";
import SwimmingPoolInsertPage from "./SwimmingPools/insert";
import SwimmingPoolEditPage from "./SwimmingPools/edit";
import TemplatesPage from "./Templates/index";
import TemplateInsertPage from "./Templates/insert";
import TemplateEditPage from "./Templates/edit";
import TemplateBuilder from "./Templates/builder";
import InspectionsPage from "./Inspections/index";
import InspectionInsertPage from "./Inspections/insert";
import InspectionEditPage from "./Inspections/edit";
import InspectionExecutePage from "./Inspections/execute";
import InspectionReportPage from "./Inspections/rapport";
import EmailTemplatesPage from "./EmailTemplates/index";
import CertificatenPage from "./Certificaten/index";
import ConclusieItemsPage from "./ConclusieItems/index";

const ZwembadinspectiesRouter = () => {
  return (
    <Routes>
      <Route exact path="/" element={<RequireAuth><ZwembadinspectiesDashboard /></RequireAuth>} />

      {/* Zwembaden routes */}
      <Route exact path="/zwembaden" element={<RequireAuth><SwimmingPoolsPage /></RequireAuth>} />
      <Route exact path="/zwembaden/nieuw" element={<RequireAuth><SwimmingPoolInsertPage /></RequireAuth>} />
      <Route exact path="/zwembaden/:id" element={<RequireAuth><SwimmingPoolEditPage /></RequireAuth>} />

      {/* Templates routes */}
      <Route exact path="/templates" element={<RequireAuth><TemplatesPage /></RequireAuth>} />
      <Route exact path="/templates/nieuw" element={<RequireAuth><TemplateBuilder /></RequireAuth>} />
      <Route exact path="/templates/builder/:id" element={<RequireAuth><TemplateBuilder /></RequireAuth>} />

      {/* Inspecties routes */}
      <Route exact path="/inspecties" element={<RequireAuth><InspectionsPage /></RequireAuth>} />
      <Route exact path="/inspecties/nieuw" element={<RequireAuth><InspectionInsertPage /></RequireAuth>} />
      <Route exact path="/inspecties/:id" element={<RequireAuth><InspectionEditPage /></RequireAuth>} />
      <Route exact path="/inspecties/:id/uitvoeren" element={<RequireAuth><InspectionExecutePage /></RequireAuth>} />
      <Route exact path="/inspecties/:id/rapport" element={<RequireAuth><InspectionReportPage /></RequireAuth>} />

      {/* Email sjablonen routes */}
      <Route exact path="/email-sjablonen" element={<RequireAuth><EmailTemplatesPage /></RequireAuth>} />

      {/* Certificaten routes */}
      <Route exact path="/certificaten" element={<RequireAuth><CertificatenPage /></RequireAuth>} />

      {/* Conclusie Items routes */}
      <Route exact path="/conclusie-items" element={<RequireAuth><ConclusieItemsPage /></RequireAuth>} />
    </Routes>
  );
};

export default ZwembadinspectiesRouter;
